// @flow

export const STEPS = {
  SELECTION: "selection",
  PRICE: "price",
  THANK_YOU: "thank_you",
  ERROR: "error",
  CONTACT_AIRLINE: "contact_airline",
  PRICE_ERROR: "price_error",
}

export type Step = $Values<typeof STEPS>

export const PAX_ATA_ACTIONS = {
  PAX: "PAX",
  AERO: "AERO",
  CS: "CS",
}

export type PaxAtaActions = $Values<typeof PAX_ATA_ACTIONS>

// CONSTANTS
export const REINITIALIZE = "passengerAta/REINITIALIZE"
export const SET_STEP = "passengerAta/SET_STEP"
export const SET_ACTIVE_FLIGHT = "passengerAta/SET_ACTIVE_FLIGHT"
export const LOAD_GUARANTEE_COVER = "passengerAta/LOAD_GUARANTEE_COVER"
export const LOAD_GUARANTEE_COVER_SUCCESS = "passengerAta/LOAD_GUARANTEE_COVER_SUCCESS"
export const SUBMIT_SELECTED_FLIGHT = "passengerAta/SUBMIT_SELECTED_FLIGHT"
export const SUBMIT_SELECTED_FLIGHT_SUCCESS = "passengerAta/SUBMIT_SELECTED_FLIGHT_SUCCESS"
export const SUBMIT_SELECTED_FLIGHT_FAILURE = "passengerAta/SUBMIT_SELECTED_FLIGHT_FAILURE"
export const LOAD_GUARANTEE_COVER_FAILURE = "passengerAta/LOAD_GUARANTEE_COVER_FAILURE"
export const LOAD_GUARANTEE_COVER_REQUEST = "passengerAta/LOAD_GUARANTEE_COVER_REQUEST"
export const CONFIRM_FLIGHT_SELECTION = "passengerAta/CONFIRM_FLIGHT_SELECTION"
export const CONFIRM_FLIGHT_SELECTION_FAILURE = "passengerAta/CONFIRM_FLIGHT_SELECTION_FAILURE"
export const CONFIRM_FLIGHT_SELECTION_SUCCESS = "passengerAta/CONFIRM_FLIGHT_SELECTION_SUCCESS"
